import Vue from 'vue'
Vue.filter('width', function(val){
    if (val.length > 8) {
        return val.substring(0,8) + '...'
        }else {
        return val
        }
})